(function($, d, w) {

	w.ZP_EVENT_TAB_TOGGLE = "zp.tab.toggle";

	$(w).on(w.ZP_READY, onInit);

	function onInit()  {
		var $elements = $('.zp_tab');
		if($elements.length > 0) {
			$elements.each(function(index, $element) {
				var $ele = $($element);
				var $nav = $ele.find("> .nav-tabs");
				var $navItems = $ele.find("> .tab-content > .zp_tab_element > .nav-item");
				$navItems.appendTo($nav);
				if($ele.get(0).hasAttribute("data-child-elements")) {
					var childElements;
					var childElementsStr = $ele.attr("data-child-elements");
					if(childElementsStr.indexOf(',') > -1) {
						childElements = $ele.attr("data-child-elements").split(",");
					} else {
						childElements = [childElementsStr];
					}
					var $childElementsObjs = [];
					var i = 0;
					while(i < childElements.length) {
						var childElement = childElements[i];
						$ele.find('> .tab-content > .zp_tab_element.active ' + childElement).addClass("zp-child-tab-active");
						var $childElement = $ele.find('> .tab-content > .zp_tab_element ' + childElement);
						$childElement.addClass("zp-tab-child");
						i = i + 1;
					}
					$ele.data("has_child_elements", true);
				}
				$ele.find('a[data-toggle="tab"]').on('shown.bs.tab', onShow);
				$ele.find('a[data-toggle="tab"]').on('hidden.bs.tab', onHide);
			});
		}
	}

	function onShow() {
		var $ele = $(this);
		var $container = $ele.closest(".zp_tab");
		var $new = $container.find("> .tab-content > .zp_tab_element > .nav-item > .nav-link.active");
		if($container.data("has_child_elements")) {
			$container.find(".zp-tab-child").removeClass("zp-tab-child-active");
			$container.find("> .tab-content > .zp_tab_element.active .zp-tab-child").addClass("zp-tab-child-active");
		}
		$(w).trigger(w.ZP_EVENT_TAB_TOGGLE, [{element:$new, status:"open"}]);
		$(w).resize();

	}

	function onHide() {
		var $ele = $(this);
		var $container = $ele.closest(".zp_tab");
		var $new = $container.find("> .tab-content > .zp_tab_element > .nav-item > .nav-link.active");
		if($container.data("has_child_elements")) {
			$container.find(".zp-tab-child").removeClass("zp-tab-child-active");
			$container.find("> .tab-content > .zp_tab_element.active .zp-tab-child").addClass("zp-tab-child-active");
		}
		$(w).trigger(w.ZP_EVENT_TAB_TOGGLE, [{element:$new, status:"open"}]);
		$(w).resize();
	}


})(jQuery, document, window);